import React from 'react';

import CoverSheet from '../general/coverSheet';
import ETAnomalyPDF from '../et/ETAnomalyPDF';
import MTInspectionReport from './mtiInspectionReport';
import MTSummarySheet from './mtSummarySheet';
import PDFInfoSheet from '../../../themed/pdf/pdfInfoSheet';
import PDFPhotoPage from '../../../themed/pdf/pdfPhotoPage';
import PDFPage from '../../../themed/pdf/pdfPage';

import withPDF from '../../../hoc/withPDF';

import * as models from '../../../../utils/models';
import * as utils from '../../../../utils/utilities';

interface MTReportProps {
	anomalyData: models.VTEquipmentAnomalyData[];
	projectDetails: models.Project;
	coverSheetData: models.MTCoverData;
	drawingData: models.PDFImageProps[];
	mtReportData: models.MTInspectionReportData;
	viPageData: models.PDFVIPageProps;
	photographicData: models.PDFImageProps[];
}

const MTReport = (props: MTReportProps): JSX.Element => {
	const { projectDetails } = props;

	const standardCriteriaItems: models.CoverDataItem[] = [
		{
			label: '1. Qualification of NDT Personnel',
			value: props.coverSheetData?.ndtQualification,
		},

		{
			label: '2. Non Destructive Testing',
			value: props.coverSheetData?.nonDestructiveTesting,
		},
		{
			label:
				'3.  Damage Mechanisms Affecting Fixed Equipment in the Refining Industry',
			value: props.coverSheetData?.damageMechanisms,
		},
	];

	const referenceDocuments: models.CoverDataItem[] = [
		{
			label: '1. Scope Of Work',
			value: props.coverSheetData?.scopeOfWork,
		},
		{
			label: '2. Visual Examination Procedure',
			value: props.coverSheetData?.veProcedure,
		},
		{
			label: '3. Magnetic Particle Examination Procedure',
			value: props.coverSheetData?.mpeProcedure,
		},
	];

	const pageSubtitle: string =
		'Document Number: ' + projectDetails.documentNumber;

	return (
		<React.Fragment>
			<PDFInfoSheet
				companyUrl={projectDetails.organisation.organisationLogo}
				documentNo={projectDetails.documentNumber}
				clientName={projectDetails.organisationName}
				facility={projectDetails.facilityName}
				reportTitle={projectDetails.projectTitle}
			/>

			<PDFPage
				pageDetails={utils.getPageDetails('Cover Sheet', pageSubtitle)}
				projectDetails={projectDetails}
			>
				<CoverSheet
					overviewData={overviewData}
					referenceDocuments={referenceDocuments}
					standardCriteriaItems={standardCriteriaItems}
				/>
			</PDFPage>

			<PDFPage
				pageDetails={utils.getPageDetails('Summary Sheet')}
				projectDetails={projectDetails}
			>
				<MTSummarySheet {...props.viPageData} />
			</PDFPage>

			<PDFPage
				projectDetails={projectDetails}
				pageDetails={utils.getPageDetails('Magnetic Particle Testing Report')}
			>
				<MTInspectionReport
					projectDetails={projectDetails}
					{...props.mtReportData}
				/>
			</PDFPage>

			<PDFPage
				projectDetails={projectDetails}
				pageDetails={utils.getPageDetails('Drawing Sheet')}
			>
				<PDFPhotoPage photos={props.drawingData} />
			</PDFPage>

			<ETAnomalyPDF data={props.anomalyData} project={projectDetails} />

			<PDFPage
				projectDetails={projectDetails}
				pageDetails={utils.getPageDetails('Photographic Record')}
			>
				<PDFPhotoPage photos={props.photographicData} />
			</PDFPage>
		</React.Fragment>
	);
};

const overviewData: models.CoverDataOverview[] = [
	{ report: '1. Cover Sheet', required: 'Yes', page: '2' },
	{ report: '2. Summary Sheet', required: 'Yes', page: '3' },
	{
		report: '3. Drawing',
		required: 'Yes',
		page: '4',
	},
	{
		report: '4. MPI Report',
		required: 'Yes',
		page: '5',
	},
	{
		report: '5. Photographic Record',
		required: 'Yes',
		page: '6',
	},
];

export default withPDF(MTReport);
